<template>
  <div class="wrapper df fdr fww">
    <h2 class="w100p">Project Totals</h2>

    <div class="w50p p20">
      <div class="box df fdc totals-box">
        <span class="top-blue-bar">
          <p>
            By Feature
          </p>
        </span>
        <span class="bottom-section">
          <div  class="module-section df fdc"
                v-for="(module, key3) in $store.getters.currentProjectModules">
            <span class="module-heading df aic">
              {{ module.name }}
            </span>
            <div class="module-components df fdc">
              <span class="module-component df aic jcsb"
                    v-for="(component, key2) in module.components">
                <p>
                  {{ component.name }}
                </p>
                <p>
                  {{ priceSumComponent(key3, key2) }}
                </p>
              </span>
            </div>
          </div>
          <div class="module-section df fdc">
            <span class="module-heading df aic">
              Overrides
            </span>
            <div class="module-components df fdc">
              <span v-for="(override, keyOverride) in $store.getters.currentProjectOverrides" class="module-component df aic jcsb">
                <p>
                  {{ override.name }}
                </p>
                <p>
                  {{ formattedPrice(totalOverridePrice(keyOverride)) }}
                </p>
              </span>
            </div>
          </div>
          <hr/>
          <span class="df dfc">
            <div class="module-components df fdc f1">
              <span class="module-component sums-component df aic jcsb">
                <p class="df fdc">
                  <span class="sum">
                    Total
                  </span>
                  <span class="cost">
                    My Cost
                  </span>
                </p>
                <p class="df fdc">
                  <span class="sum">
                    {{ totalPriceSum() }}
                  </span>
                  <span class="cost">
                    {{ totalCostSum() }}
                  </span>
                </p>
              </span>
            </div>
          </span>
        </span>
      </div>
      <div class="box df fdc rates-box">
        <span class="top-grey-bar">
          <p>
            Rates And Totals
          </p>
        </span>
        <span class="bottom-section">

          <div class="rates-row df fdr jcsb padded-row">
            <div class="rates-row-col w50 df fdc">
              <p class="title wu">
                Blended Rate
              </p>
              <p class="amount">
                ${{ $store.getters.currentProjectRate }}<span> / h</span>
              </p>
            </div>
            <div class="rates-row-col w50 df fdc">
              <p class="title wu">
                Avg. Hourly Cost
              </p>
              <p class="amount">
                ${{ $store.getters.currentProjectContingency }}<span> / h</span>
              </p>
            </div>
          </div>
          <div class="rates-row">
            <p class="totals-heading">Totals</p>
          </div>
          <div class="rates-row df fdr jcsb">
            <div class="rates-row-col w50 df fdr">
              <span class="title">Hours</span>
              <span class="amount">{{ totalHoursSum() }}</span>
            </div>
            <div class="rates-row-col w50 df fdr">
              <span class="title">Base Price</span>
              <span class="amount">{{ formattedPrice(basePrice())}}</span>
            </div>
          </div>
          <div class="rates-row df fdr jcsb">
            <div class="rates-row-col w50 df fdr">
              <span class="title">Days</span>
              <span class="amount">{{ totalDaysSum() }}</span>
            </div>
            <div class="rates-row-col w50 df fdr">
              <span class="title">Overrides</span>
              <span class="amount">{{ formattedPrice(totalOverride()) }}</span>
            </div>
          </div>
          <div class="rates-row df fdr jcsb">
            <div class="rates-row-col w50 df fdr">
              <span class="title">Weeks</span>
              <span class="amount">{{ totalWeeksSum() }}</span>
            </div>
            <div class="rates-row-col w50 df fdr">
              <span class="title">Full Price</span>
              <span class="amount">{{ totalPriceSum() }}</span>
            </div>
          </div>
          <div class="rates-row df fdr jcsb">
            <div class="rates-row-col w5 df fdr">
              <span class="title">Months</span>
              <span class="amount">{{ totalMonthsSum() }}</span>
            </div>
            <div class="rates-row-col w50 df fdr">
              <span class="title">Cost</span>
              <span class="amount">{{ totalCostSum() }}</span>
            </div>
          </div>
          <div class="rates-row df fdr jcsb">
            <div class="rates-row-col w50 df fdr">
              <span class="title"></span>
              <span class="amount"></span>
            </div>
            <div class="rates-row-col w50 df fdr">
              <span class="title">Margin</span>
              <span class="amount">{{ totalMargin() }}</span>
            </div>
          </div>

        </span>
      </div>
    </div>


    <div class="w50p p20">
      <div class="box df fdc totals-box">
        <span class="top-blue-bar">
          <p>
            By Task
          </p>
        </span>
        <span class="bottom-section">


          <div class="module-section df fdc">
            <span class="module-heading df aic">
              Fixed Price Items
            </span>
            <div class="module-components df fdc">
              <span class="module-component df aic jcsb">
                <p>
                  Fixed Cost
                </p>
                <p>
                  {{ sumFixedPrices() }}
                </p>
              </span>
            </div>
          </div>


          <div class="module-section df fdc">
            <span class="module-heading df aic">
              Hourly Price
            </span>
            <div class="module-components df fdc">
              <span class="module-component df aic jcsb"
                    v-for="(component, key2) in $store.getters.currentProjectModuleColumns.hourlyElements">
                <p>
                  {{ component.name }}
                </p>
                <p>
                  {{ sumHourlyPrices(key2) }}
                </p>
              </span>
            </div>
          </div>


          <div class="module-section df fdc">
            <span class="module-heading df aic">
              Variable Price
            </span>
            <div class="module-components df fdc">
              <span class="module-component df aic jcsb"
                    v-for="(component, key2) in $store.getters.currentProjectModuleColumns.percentTasks">
                <p>
                  {{ component.name }}
                </p>
                <p>
                  {{ sumPercentPrices(key2) }}
                </p>
              </span>
            </div>
          </div>


          <div class="module-section df fdc">
            <span class="module-heading df aic">
              Overrides
            </span>
            <div class="module-components df fdc">
              <span v-for="(override, keyOverride) in $store.getters.currentProjectOverrides" class="module-component df aic jcsb">
                <p>
                  {{ override.name }}
                </p>
                <p>
                  {{ formattedPrice(totalOverridePrice(keyOverride)) }}
                </p>
              </span>
            </div>
          </div>

          <hr/>

          <span class="df dfc">
            <div class="module-components df fdc f1">
              <span class="module-component sums-component df aic jcsb">
                <p class="df fdc">
                  <span class="sum">
                    Total
                  </span>
                  <span class="cost">
                    My Cost
                  </span>
                </p>
                <p class="df fdc">
                  <span class="sum">
                    {{ totalPriceSum() }}
                  </span>
                  <span class="cost">
                    {{ totalCostSum() }}
                  </span>
                </p>
              </span>
            </div>
          </span>
        </span>
      </div>
    </div>

  </div>
</template>

<script>
// import ProjectTask from '../components/ProjectTask'
import ProjectUtil from '../../util/project';

export default {
  name: 'ProjectPageTotals',
  data () {
    return {
      selectedPriceRange: 'mid'
    }
  },
  props: [],
  components: {
    // ProjectTask
  },
  methods: {
    totalOverride () {
      return ProjectUtil.totalOverridePrice(this.$store.getters.currentProjectOverrides, this.basePrice())
    },
    totalOverridePrice (overrideKey) {
      return ProjectUtil.overrideByKey(overrideKey, this.$store.getters.currentProjectOverrides, this.basePrice())
    },
    hoursTotalForPhase (phase) {
      var totalForPhase = 0
      var columns1 = this.$store.getters.currentProjectModuleColumns.hourlyElements
      var columns2 = this.$store.getters.currentProjectModuleColumns.percentTasks
      var columns3 = this.$store.getters.currentProjectModuleColumns.fixedElements
      var phases = this.$store.getters.currentProjectPhases

      for (var task in columns1) {
        var totalForTask = this.sumHourlyHours(task)
        // totalForTask = parseFloat(totalForTask.replace(/\$|,/g, ''))
        var _list = phases[phase].list
        var percentForTaskInPhase = 0
          // phases[phase].list.filter(v => v[0] === task)[0]
        if (_list) {
          console.log('list', _list)
          var existingPercent = _list.filter(v => v[0] == task)[0]
          if (existingPercent) {
            percentForTaskInPhase = existingPercent[1]
          }
        }
        console.log('Adding Task3', task, totalForTask, percentForTaskInPhase)
        if (percentForTaskInPhase) {
          percentForTaskInPhase = percentForTaskInPhase
          totalForTask = (totalForTask * percentForTaskInPhase) / 100
          totalForPhase = totalForPhase + totalForTask
        }
      }

      for (var task in columns2) {
        var totalForTask = this.sumPercentHours(task)
        // totalForTask = parseFloat(totalForTask.replace(/\$|,/g, ''))
        var _list = phases[phase].list2
        var percentForTaskInPhase = 0
          // phases[phase].list.filter(v => v[0] === task)[0]
        if (_list) {
          console.log('list', _list)
          var existingPercent = _list.filter(v => v[0] == task)[0]
          if (existingPercent) {
            percentForTaskInPhase = existingPercent[1]
          }
        }
        console.log('Adding Task3', task, totalForTask, percentForTaskInPhase)
        if (percentForTaskInPhase) {
          percentForTaskInPhase = percentForTaskInPhase
          totalForTask = (totalForTask * percentForTaskInPhase) / 100
          totalForPhase = totalForPhase + totalForTask
        }
      }

      for (var task in columns3) {
        var totalForTask = this.sumFixedHours(task)
        // totalForTask = parseFloat(totalForTask.replace(/\$|,/g, ''))
        var _list = phases[phase].list3
        var percentForTaskInPhase = 0
          // phases[phase].list.filter(v => v[0] === task)[0]
        if (_list) {
          console.log('list', _list)
          var existingPercent = _list.filter(v => v[0] == task)[0]
          if (existingPercent) {
            percentForTaskInPhase = existingPercent[1]
          }
        }
        console.log('Adding Task3', task, totalForTask, percentForTaskInPhase)
        if (percentForTaskInPhase) {
          percentForTaskInPhase = percentForTaskInPhase
          totalForTask = (totalForTask * percentForTaskInPhase) / 100
          totalForPhase = totalForPhase + totalForTask
        }
      }

      return totalForPhase
    },
    priceTotalForPhase (phase) {
      var totalForPhase = 0
      var columns1 = this.$store.getters.currentProjectModuleColumns.hourlyElements
      var columns2 = this.$store.getters.currentProjectModuleColumns.percentTasks
      var columns3 = this.$store.getters.currentProjectModuleColumns.fixedElements
      var phases = this.$store.getters.currentProjectPhases

      for (var task in columns1) {
        var totalForTask = this.sumHourlyPrices(task)
        totalForTask = parseFloat(totalForTask.replace(/\$|,/g, ''))
        var _list = phases[phase].list
        var percentForTaskInPhase = 0
          // phases[phase].list.filter(v => v[0] === task)[0]
        if (_list) {
          console.log('list', _list)
          var existingPercent = _list.filter(v => v[0] == task)[0]
          if (existingPercent) {
            percentForTaskInPhase = existingPercent[1]
          }
        }
        console.log('Adding Task3', task, totalForTask, percentForTaskInPhase)
        if (percentForTaskInPhase) {
          percentForTaskInPhase = percentForTaskInPhase
          totalForTask = (totalForTask * percentForTaskInPhase) / 100
          totalForPhase = totalForPhase + totalForTask
          // ,,,,,,,
        }
      }

      for (var task in columns2) {
        var totalForTask = this.sumPercentPrices(task)
        totalForTask = parseFloat(totalForTask.replace(/\$|,/g, ''))
        var _list = phases[phase].list2
        var percentForTaskInPhase = 0
          // phases[phase].list.filter(v => v[0] === task)[0]
        if (_list) {
          console.log('list', _list)
          var existingPercent = _list.filter(v => v[0] == task)[0]
          if (existingPercent) {
            percentForTaskInPhase = existingPercent[1]
          }
        }
        console.log('Adding Task3', task, totalForTask, percentForTaskInPhase)
        if (percentForTaskInPhase) {
          percentForTaskInPhase = percentForTaskInPhase
          totalForTask = (totalForTask * percentForTaskInPhase) / 100
          totalForPhase = totalForPhase + totalForTask
        }
      }

      for (var task in columns3) {
        var totalForTask = this.sumFixedPrices(task)
        totalForTask = parseFloat(totalForTask.replace(/\$|,/g, ''))
        var _list = phases[phase].list3
        var percentForTaskInPhase = 0
          // phases[phase].list.filter(v => v[0] === task)[0]
        if (_list) {
          console.log('list', _list)
          var existingPercent = _list.filter(v => v[0] == task)[0]
          if (existingPercent) {
            percentForTaskInPhase = existingPercent[1]
          }
        }
        console.log('Adding Task3', task, totalForTask, percentForTaskInPhase)
        if (percentForTaskInPhase) {
          percentForTaskInPhase = percentForTaskInPhase
          totalForTask = (totalForTask * percentForTaskInPhase) / 100
          totalForPhase = totalForPhase + totalForTask
        }
      }


// formattedPrice(totalOverridePrice(keyOverride))


      return totalForPhase
    },
    priceTotalForPhase (phase) {
      var totalForPhase = 0
      var columns1 = this.$store.getters.currentProjectModuleColumns.hourlyElements
      var columns2 = this.$store.getters.currentProjectModuleColumns.percentTasks
      var columns3 = this.$store.getters.currentProjectModuleColumns.fixedElements
      var phases = this.$store.getters.currentProjectPhases

      for (var task in columns1) {
        var totalForTask = this.sumHourlyPrices(task)
        totalForTask = parseFloat(totalForTask.replace(/\$|,/g, ''))
        var _list = phases[phase].list
        var percentForTaskInPhase = 0
          // phases[phase].list.filter(v => v[0] === task)[0]
        if (_list) {
          console.log('list', _list)
          var existingPercent = _list.filter(v => v[0] == task)[0]
          if (existingPercent) {
            percentForTaskInPhase = existingPercent[1]
          }
        }
        console.log('Adding Task3', task, totalForTask, percentForTaskInPhase)
        if (percentForTaskInPhase) {
          percentForTaskInPhase = percentForTaskInPhase
          totalForTask = (totalForTask * percentForTaskInPhase) / 100
          totalForPhase = totalForPhase + totalForTask
        }
      }

      for (var task in columns2) {
        var totalForTask = this.sumPercentPrices(task)
        totalForTask = parseFloat(totalForTask.replace(/\$|,/g, ''))
        var _list = phases[phase].list2
        var percentForTaskInPhase = 0
          // phases[phase].list.filter(v => v[0] === task)[0]
        if (_list) {
          console.log('list', _list)
          var existingPercent = _list.filter(v => v[0] == task)[0]
          if (existingPercent) {
            percentForTaskInPhase = existingPercent[1]
          }
        }
        console.log('Adding Task3', task, totalForTask, percentForTaskInPhase)
        if (percentForTaskInPhase) {
          percentForTaskInPhase = percentForTaskInPhase
          totalForTask = (totalForTask * percentForTaskInPhase) / 100
          totalForPhase = totalForPhase + totalForTask
        }
      }

      for (var task in columns3) {
        var totalForTask = this.sumFixedPrices(task)
        totalForTask = parseFloat(totalForTask.replace(/\$|,/g, ''))
        var _list = phases[phase].list3
        var percentForTaskInPhase = 0
          // phases[phase].list.filter(v => v[0] === task)[0]
        if (_list) {
          console.log('list', _list)
          var existingPercent = _list.filter(v => v[0] == task)[0]
          if (existingPercent) {
            percentForTaskInPhase = existingPercent[1]
          }
        }
        console.log('Adding Task3', task, totalForTask, percentForTaskInPhase)
        if (percentForTaskInPhase) {
          percentForTaskInPhase = percentForTaskInPhase
          totalForTask = (totalForTask * percentForTaskInPhase) / 100
          totalForPhase = totalForPhase + totalForTask
        }
      }
      return totalForPhase
    },
    formattedPrice (price) {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      })

      return formatter.format(price) // "$1,000.00"
    },

    sumHourlyHours (index) {
      var hours = 0
      var modules = this.$store.getters.currentProjectModules
      for (var module in modules) {
        for (var component in modules[module].components) {
          hours = hours + modules[module].components[component].moduleColumns.hourlyElements[index][this.selectedPriceRange]
        }
      }
      return hours
    },
    sumHourlyPrices (index) {
      var hours = 0
      var modules = this.$store.getters.currentProjectModules
      for (var module in modules) {
        for (var component in modules[module].components) {
          hours = hours + (+modules[module].components[component].moduleColumns.hourlyElements[index][this.selectedPriceRange])
        }
      }
      var rate = this.$store.getters.currentProjectRate

      if (this.$store.getters.currentProjectModuleColumns.hourlyElements[index].hourlyRateOverride && this.$store.getters.currentProjectModuleColumns.hourlyElements[index].useTaskRate) {
        rate = this.$store.getters.currentProjectModuleColumns.hourlyElements[index].hourlyRateOverride
      }

      var hourlyCost = 1
      var sum = hours * rate

      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      })

      return formatter.format(sum)
      // return sum
    },
    sumPercentHours (index) {
      var sum = 0
      var modules = this.$store.getters.currentProjectModules
      var columns = this.$store.getters.currentProjectModuleColumns

      for (var module in modules) {
        for (var component in modules[module].components) {

          var hours = 0
          for (var task in modules[module].components[component].moduleColumns.hourlyElements) {
            hours = hours + (+modules[module].components[component].moduleColumns.hourlyElements[task][this.selectedPriceRange])
          }
          var _rate = this.$store.getters.currentProjectRate
          if (columns.percentTasks[index].hourlyRateOverride && columns.percentTasks[index].useTaskRate) {
              _rate = columns.percentTasks[index].hourlyRateOverride
          }
          var costForTask = hours
          var percent = columns.percentTasks[index].taskPercentOverride || 0
          if (modules[module].components[component].moduleColumns.percentTasks[index][this.selectedPriceRange]) {
            percent = (+modules[module].components[component].moduleColumns.percentTasks[index][this.selectedPriceRange])
          }

          sum = sum + (costForTask * (percent/100))
        }
      }

      return sum
    },
    sumPercentPrices (index) {
      var sum = 0
      var modules = this.$store.getters.currentProjectModules
      var columns = this.$store.getters.currentProjectModuleColumns

      for (var module in modules) {
        for (var component in modules[module].components) {

          var hours = 0
          for (var task in modules[module].components[component].moduleColumns.hourlyElements) {
            hours = hours + (+modules[module].components[component].moduleColumns.hourlyElements[task][this.selectedPriceRange])
          }
          var _rate = this.$store.getters.currentProjectRate
          if (columns.percentTasks[index].hourlyRateOverride && columns.percentTasks[index].useTaskRate) {
              _rate = columns.percentTasks[index].hourlyRateOverride
          }
          var costForTask = hours * _rate
          var percent = columns.percentTasks[index].taskPercentOverride || 0
          if (modules[module].components[component].moduleColumns.percentTasks[index][this.selectedPriceRange]) {
            percent = +modules[module].components[component].moduleColumns.percentTasks[index][this.selectedPriceRange]
          }

          sum = sum + (costForTask * (percent/100))
        }
      }

      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      })

      return formatter.format(sum)
    },
    sumFixedHours () {
      var hours = 0
      return hours

      // return sum
    },
    sumFixedPrices () {
      var sum = 0
      var modules = this.$store.getters.currentProjectModules
      for (var module in modules) {
        for (var component in modules[module].components) {
          sum = sum + (+modules[module].components[component].moduleColumns.fixedElements[0][this.selectedPriceRange])
        }
      }
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      })

      return formatter.format(sum)

      // return sum
    },
    // Margin:  Full Price - Cost
    totalMargin () {
      return ProjectUtil.priceFormatterValue(this.totalPriceSumNoFormat() - this.totalCostSumNoFormat())
    },
    totalPriceSum () {
      return ProjectUtil.priceFormatterValue(this.totalPriceSumNoFormat())
    },
    // Full Price:  Base Price + Overrides 
    totalPriceSumNoFormat () {
      var rate = this.$store.getters.currentProjectRate
      var overrides = this.$store.getters.currentProjectOverrides
      var modules = this.$store.getters.currentProjectModules
      var columns = this.$store.getters.currentProjectModuleColumns
      return ProjectUtil.totalPriceWithOverrides(modules, columns, rate, overrides)
    },
    priceSumComponent (m_key, c_key) {
      const total = ProjectUtil.componentPrice(
        this.$store.getters.currentProjectModules[m_key].components[c_key],
        this.$store.getters.currentProjectModuleColumns,
        this.$store.getters.currentProjectRate
      )
      return ProjectUtil.priceFormatterValue(total)
    },
    // All Fixed price + All Hours * (project blended rate / resource rate)
    basePrice() {
      return ProjectUtil.totalPrice(
        this.$store.getters.currentProjectModules,
        this.$store.getters.currentProjectModuleColumns,
        this.$store.getters.currentProjectRate
      )
    },
    totalCostSum () {
      var priceTotal = ProjectUtil.totalPrice(
        this.$store.getters.currentProjectModules,
        this.$store.getters.currentProjectModuleColumns,
        this.$store.getters.currentProjectContingency
      )
      return ProjectUtil.priceFormatterValue(priceTotal)
    },
    // All Fixed price + All Hours * (project hourly cost or resource hourly cost)
    totalCostSumNoFormat () {
      return ProjectUtil.totalPrice(
        this.$store.getters.currentProjectModules,
        this.$store.getters.currentProjectModuleColumns,
        this.$store.getters.currentProjectContingency
      )
    },
    totalHoursSum () {
      var modules = this.$store.getters.currentProjectModules
      var columns = this.$store.getters.currentProjectModuleColumns
      return ProjectUtil.totalHours(modules, columns)
    },
    totalDaysSum () {
      return (this.totalHoursSum()/(8)).toFixed(2)
    },
    totalWeeksSum () {
      return (this.totalHoursSum()/(8*7)).toFixed(2)
    },
    totalMonthsSum () {
      return (this.totalHoursSum()/(8*30)).toFixed(2)
    }
  },
  computed: {

  },
  created () {
    console.log('** Totals Component Loaded')
  }
}
</script>

<style scoped lang="scss">
@import "../../styles/settings.scss";
h2 {
  color: black;
  margin-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
}


.wrap {
  position: relative;
}


//
// Wrapper
//
.wrapper {
  position: relative;
  top: 135px;
  padding: 40px 30px;
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;

  // Responsive Style
  // @media max-width: 1024px
  @media(max-width: 1024px) {
    top: 200px;
  }

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    display: block;
    max-width: unset;
    margin-left: 0px;
    margin-right: 0px;
    padding-left: 20px;
    padding-right: 20px;

    // h2
    h2 {
      padding-left: 0px;
      padding-right: 0px;
    }

    // w50p
    > .w50p {
      width: auto;
      padding-left: 0px;
      padding-right: 0px;
    }
  }

  // Responsive Style
  // @media max-width: 520px
  @media(max-width: 520px) {
    top: 245px;
  }
}

.box {
}

.top-blue-bar {
  padding: 15px 25px;
  background-color: $primaryColor;
  text-transform: uppercase;
  font-size: 16px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  color: #FFFFFF;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 18px;
}
.top-grey-bar {
  padding: 15px 25px;
  background-color: #f5f5f5;
  text-transform: uppercase;
  font-size: 16px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  color: #000;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 18px;
}
.bottom-section {
  /*padding: 15px 25px;*/
}
.module-heading, .module-component {
  height: 40px;
}
.module-heading {
  /*width: 100%;*/
  background-color: $primaryLightColor3;
  /*color: white;*/
  padding: 0 25px;
  font-weight: 500;
}

//
// Moduel Compoent
//
.module-component {
  padding: 0 25px;
  height: auto;

  // p
  p {
    word-break: break-all;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis !important;

    &:first-child {
      width: calc(100% - 135px);
    }
    &:last-child {
      width: 135px;
      text-align: right;
    }
  }
}


.totals-box {
  width: 100%;
}
.rates-box {
  margin-top: 20px;
  width: 100%;
  padding-bottom: 10px;
}
hr {
  margin-right: 25px;
  margin-left: 25px;
  margin-bottom: 25px;
}
.sums-component {
  height: unset;
  margin-bottom: 20px;
}
.sum {
  color: #000000;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 16px;
}
.cost {
  color: #848484;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 16px;
}

.w50 {
  width: 50%;
}


//
// Rates Row
//
.rates-row {
    padding: 15px 25px;

  // Responsive Style
  // @media max-width: 520px
  @media(max-width: 520px) {
    display: block;

    // padded row
    &.padded-row {
      display: flex;
    }
  }
}


//
// Rates Row Col
//
.rates-row-col {
  // title
  .title {
    color: #000000;
    font-size: 14px;
    letter-spacing: 0.5px;
    line-height: 25px;
    font-weight: 500;
    width: 120px;
  }

  // amount
  .amount {
    color: #000000;
    font-size: 24px;
    line-height: 26px;
    span {
      color: #848484;
    }
  }

  // Responsive Style
  // @media max-width: 520px
  @media(max-width: 520px) {
    dislay: block;
    width: 100%;
  }
}


.totals-heading {
  color: #000000;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 25px;
  text-transform: uppercase;
}

.wu {
  width: unset !important;
}

.padded-row {
  margin-top: 25px;
  margin-bottom: 15px;
}
.mb20 {
  margin-bottom: 20px;
}
</style>
